import { render, staticRenderFns } from "./Formulario.vue?vue&type=template&id=29b10721&scoped=true"
import script from "./Formulario.vue?vue&type=script&lang=ts"
export * from "./Formulario.vue?vue&type=script&lang=ts"
import style0 from "./Formulario.vue?vue&type=style&index=0&id=29b10721&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b10721",
  null
  
)

export default component.exports